import html2canvas from "html2canvas";

export async function saveElementAsImage(
  element: HTMLElement,
  fileName = "account-details.png"
): Promise<void> {
  const canvas = await html2canvas(element, {
    backgroundColor: "#000000",
    scale: 2,
  });

  const dataUrl = canvas.toDataURL("image/png");

  const link = document.createElement("a");
  link.href = dataUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
